import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user completes the onboarding job title step',
  name: 'completed_onboarding_job_title',
  params: [
    {
      description: 'Selected job title',
      name: 'answer',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the user skipped this step',
      name: 'skipped',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Custom answer when "Other" is selected',
      name: 'custom_response',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
